import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import MarketplaceTitle from "components/CreateWizard/Marketplace/MarketplaceTitle";

import * as blueprintReducer from "containers/Blueprint/reducer";

class MarketplaceTitleContainer extends React.Component {
  render() {
    return <MarketplaceTitle {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateName: (name) => dispatch(blueprintReducer.updateMarketplaceName(ownProps.blueprintId, name))
});

const mapStateToProps = (state, ownProps) => ({
  name: blueprintReducer.getMarketplaceName(state, ownProps.blueprintId)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(MarketplaceTitleContainer);
